import http from '../../service/http'

export const PosPayAPI = {
    getOrder(orderId) {
        return http.get('/orders/' + orderId).then(res => {
            if (res.status === 200) {
                return res.data
            }
        })
    },
    getBooking(reservation_code, reservation_id) {
        return http.get('/books/' + reservation_id, {
            params: {
                reservation_code
            }
        }).then(res => {
            if (res.status === 200) {
                return res.data
            }
        })
    },

}

function mockOrder() {
    return {
        "id": 3,
        "status": "pending",
        "status_humanize": "待支付",
        "datetime": null,
        "formated_datetime": null,
        "uuid": "e0e9da63-212d-40fe-8e05-00c3bdf2260d",
        "tax": "0.0",
        "delivery_fee": "0.0",
        "total_fee": "100.0",
        "can_cancel": false,
        "estimated_delivery_datetime": null,
        "formated_created_at": "2023年12月18日 14:52",
        "formated_estimated_delivery_datetime": null,
        "format_fee": "￥100",
        "total_amount": "0.0",
        "format_total_amount": "￥0",
        "book_id": null,
        "payment": {
            "id": 3,
            "uuid": "20231218145229357bznp",
            "channel": null,
            "channel_humanize": null,
            "expire_at": "2023-12-18T15:07:29.000+08:00",
            "price": 100,
            "format_price": "100",
            "channels": "wx,alipay"
        },
        "restaurant": {
            "id": 85,
            "name": "",
            "cover": "https://static-assets.diningcity.asia/restaurantpictures/restaurant_picture.png",
            "phone": "139",
            "dirname": "Dan Schmitt"
        },
        "booking": null,
        "delivery": null,
        "qr_code": {
            "key": "126287dd716f5843",
            "qrcode_url": "https://api.diningcity.asia/public/qr_code/render_png?text=https://api.diningcity.asia/public/qr_codes/126287dd716f5843&size=",
            "scanned_at": null,
            "action": "open_order_pospay",
            "args": {
                "order_id": 3,
                "book_id": null,
                "reservation_code": null
            },
            "is_scanned": false
        },
        "items": [
            {
                "fee": "100.0",
                "quantity": 1,
                "title": "deal name",
                "format_fee": "￥100",
                "product_type": "VoucherBatch",
                "entity": {
                    "id": 249,
                    "code": "men31p",
                    "start_at": "2023-12-18T00:00:00.000+08:00",
                    "end_at": "2024-01-18T23:59:59.000+08:00",
                    "project": "diningcity",
                    "points": 1,
                    "used": false,
                    "expired": false,
                    "can_refund": false,
                    "applicable": null,
                    "project_config": {
                        "title": "",
                        "project_type": "normal"
                    },
                    "detail": {
                        "title": "deal name",
                        "desc": null,
                        "id": 19,
                        "name": "deal name",
                        "code_length": 6,
                        "points_type": "fixed",
                        "points_type_humanize": "固定次数",
                        "price": "100",
                        "currency": "￥",
                        "points": 1,
                        "amount": 0,
                        "end_on": "2024年1月18日",
                        "value": null,
                        "type": "VoucherBatch",
                        "stock_count": -1,
                        "voucher_per_seat": 1,
                        "price_type": "none",
                        "batch_code": null,
                        "price_humanize": "",
                        "visible_consumer": true,
                        "validity_num": null,
                        "validity_unit": null,
                        "deal": {
                            "id": 23,
                            "name": "deal name",
                            "picture_url": "https://assets.diningcity.cn/default-placeholder.png"
                        },
                        "voucher_batch_assignment": null
                    }
                }
            }
        ]
    }
}